import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import MetricData from "src/AngularJS/Models/metric-data";
import ModuleDataGroupItem from "src/shared/models/module-data-group-item";
import { ClearViewUtils } from "src/shared/utils";
import { InteractiveBarData } from '../interactive-bar/interactive-bar.model';
import { CVLocalizationService } from "../services/cv-localization.service";
import { ObjectiveDetailsModalDataObj } from "./objectives-details.model";
import { ObjectivesDetailsService } from "./objectives-details.service";

@Component({
    selector: "cv-objectives-details",
    templateUrl: "./objectives-details.component.html",
    styleUrl: "./objectives-details.component.scss",
})
export class ObjectivesDetailsComponent implements OnInit {

    public metricData: MetricData;
    public metricName: string;
    public metricDirection: string;
    public metricType: string;
    public data: ObjectiveDetailsModalDataObj;
    public barData: InteractiveBarData;
    public groupInfo: ModuleDataGroupItem;
    public isKpiWidget: boolean;
    public showMoreEmployeeGroups = false;
    public showMoreCallGroups = false;
    public newEmployeeGroups: string[] | string = [];
    public newCallGroups: string[] | string = [];

    public MAX_CHARACTERS_GROUPS = 90;

    public employeeGroups = null;
    public callGroups = null;

    constructor(
        private activeModal: NgbActiveModal,
        private cvLocalizationService: CVLocalizationService,
        private service: ObjectivesDetailsService,
    ) { }

    async ngOnInit() {
        await this.loadLocalizations();
        await this.loadData();
    }

    async loadLocalizations() {
        const localizationPromises = [
            this.cvLocalizationService.GetSection("Common"),
            this.cvLocalizationService.GetSection("Objectives"),
            this.cvLocalizationService.GetSection("CXOne_Objectives"),
        ];
        await Promise.all(localizationPromises);
    }

    async loadData() {
        this.data = await this.service.getObjectivesDetailsData(this.isKpiWidget, this.groupInfo);
        this.barData = this.data.BarData;

        if (this.isAssignementDataAvailable()) {

            this.employeeGroups = !this.data.Assignments.empAssignAll
                ? this.data.Assignments.emp.map(group => group.GroupName).sort((a, b) => a > b ? 1 : -1)
                : this.cvLocalizationService.getCachedText("CXOne_Objectives", "All_Employee_Groups", "All Employee Groups");

            this.callGroups = !this.data.Assignments.recAssignAll
                ? this.data.Assignments.rec.map(group => group.GroupName).sort((a, b) => a > b ? 1 : -1)
                : this.cvLocalizationService.getCachedText("CXOne_Objectives", "All_Contact_Groups", "All Contact Groups");

        } else {
            this.employeeGroups = this.cvLocalizationService.getCachedText("Common", "None", "None");
            this.callGroups = this.cvLocalizationService.getCachedText("Common", "None", "None");
        }

        this.newEmployeeGroups = ClearViewUtils.joinStringsWithMax(this.employeeGroups, this.MAX_CHARACTERS_GROUPS);
        this.newCallGroups = ClearViewUtils.joinStringsWithMax(this.callGroups, this.MAX_CHARACTERS_GROUPS);

    }

    isAssignementDataAvailable() {
        return this.data.Assignments && (this.data.Assignments.emp || this.data.Assignments.empAssignAll) &&
        (this.data.Assignments.rec || this.data.Assignments.recAssignAll);
    }

    expandEmpGroupList(){
        this.showMoreEmployeeGroups = !this.showMoreEmployeeGroups;
        if (this.showMoreEmployeeGroups) {
            this.newEmployeeGroups = this.employeeGroups;
        } else {
            this.newEmployeeGroups = ClearViewUtils.joinStringsWithMax(this.employeeGroups, this.MAX_CHARACTERS_GROUPS);
        }
    }

    expandCallGroupList(){
        this.showMoreCallGroups = !this.showMoreCallGroups;
        if (this.showMoreCallGroups) {
            this.newCallGroups = this.callGroups;
        } else {
            this.newCallGroups = ClearViewUtils.joinStringsWithMax(this.callGroups, this.MAX_CHARACTERS_GROUPS);
        }
    }

    getMetricObjectiveTypeString() {
        return this.data.MetricObjectiveType === 1
            ? this.cvLocalizationService.getCachedText("Objectives", "Normalized", "Normalized")
            : this.cvLocalizationService.getCachedText("Objectives", "Count", "Count");
    }

    getMetricObjectiveDirectionString() {
        return this.metricData.Direction === 1
            ? this.cvLocalizationService.getCachedText("Objectives", "Metric_Direction_Down", "Down")
            : this.cvLocalizationService.getCachedText("Objectives", "Metric_Direction_Up", "Up");
    }

    onCancelClicked() {
        this.activeModal.close(false);
    }

}
